export const DATE_RANGE_FILTER_FROM_TEST_ID = 'filter-date-from'
export const DATE_RANGE_FILTER_TO_TEST_ID = 'filter-date-to'
